module.exports = __webpack_public_path__ + "static/backend-9188608b501b713b8446d232a4e47cd7.png";